const krw = (value: string | number): string => {
  return `${Number(value)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원`
}

export default krw
